import { Box, Grid, Typography } from '@mui/material'
import React from 'react'
import CountUp from 'react-countup';

function Experience() {
    return (
        <Box sx={{ width: '100%', my: 2 }}>
            <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', }}>
                <Typography variant='h4' component={'div'} sx={{ my: 1, textTransform: 'capitalize' }}>Customer Satisfaction</Typography>
                {/* <Box sx={{ width: '50%', mb: 1 }}>
                    <Typography variant="body1">Lorem ipsum dolor sit amet consectetur adipisicing elit. Rem officiis cumque illum, nihil consectetur eos quo consequatur molestiae aliquam et?</Typography>
                </Box> */}
            </Box>

            <Grid container spacing={2} sx={{ my: 3, mb: 8 }}>
                <Grid item xs={12} sm={6} md={4} lg={3}>
                    <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', }} >
                        <Typography variant='h5' component={'div'} sx={{ fontWeight: 700 }}><CountUp end={450} /></Typography>
                        <Typography variant='body' component={'div'} sx={{ textTransform: 'uppercase' }}>satisfaction</Typography>
                    </Box>
                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={3}>
                    <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', }} >
                        <Typography variant='h5' component={'div'} sx={{ fontWeight: 700 }}><CountUp end={350} /></Typography>
                        <Typography variant='body' component={'div'} sx={{ textTransform: 'uppercase' }}>project completed</Typography>
                    </Box>
                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={3}>
                    <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', }} >
                        <Typography variant='h5' component={'div'} sx={{ fontWeight: 700 }}><CountUp end={15} /></Typography>
                        <Typography variant='body' component={'div'} sx={{ textTransform: 'uppercase' }}>years of experience</Typography>
                    </Box>
                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={3}>
                    <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', }} >
                        <Typography variant='h5' component={'div'} sx={{ fontWeight: 700 }}><CountUp end={10} /></Typography>
                        <Typography variant='body' component={'div'} sx={{ textTransform: 'uppercase' }}>active projects</Typography>
                    </Box>
                </Grid>
            </Grid>
        </Box>
    )
}

export default Experience